/* eslint-disable prettier/prettier */
import React from "react";
import {
  Typography,
  Container,
  Grid,
  Paper,
} from "@mui/material";
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import translations from "../i18n/translations";
import { useLanguage } from "../context/LanguageContext";

// Images
import deviHero from "assets/images/devi-pic.jpeg";
import pageBg from "assets/images/plain-img5.jpg";
import cardBg from "assets/images/plain-img3.jpg";


function Home() {

  const { lang } = useLanguage();
  const t = translations[lang].home;
  return (
    <MKBox
      sx={{
        minHeight: "100vh",

        backgroundImage: `
  linear-gradient(
    rgba(239, 212, 156, 0.9),
      rgba(245, 198, 104, 0.9)
  ),
  url(${pageBg})`,

        backgroundSize: "cover",
        backgroundPosition: "center",
        py: 6,
      }}
    >
      <Container maxWidth="lg">

        {/* 🔱 HERO SECTION */}
        <MKBox
          sx={{
            position: "relative",
            height: { xs: 320, md: 480 },
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: 6,
            mb: 6,
          }}
        >
          <MKBox
            component="img"
            src={deviHero}
            alt="Sri Amba Bhavani Devi"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "brightness(0.9) saturate(1.9)",
            }}
          />

          {/* Overlay Text */}
          <MKBox
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.2))",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              pb: 4,
              textAlign: "center",
              color: "#FFD700",
            }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{ textShadow: "2px 2px 6px #000", color: "#c5d3c5" }}
            >
              {t.title}
            </Typography>
            <Typography
              variant="h6"
              sx={{ mt: 1, textShadow: "1px 1px 4px #000", color: "#c5d3c5" }}
            >
              {t.subtitle}
            </Typography>
          </MKBox>
        </MKBox>

        {/* 🔱 CONTENT CARDS */}
        <Grid container spacing={4}>

          {/* 📸 GALLERY */}
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                height: "100%",
                p: 4,
                borderRadius: 4,
                textAlign: "center",
                backgroundImage: `linear-gradient(
                 rgba(218, 178, 70, 0.48),
                  rgba(231, 211, 110, 0.9)
                ), url(${cardBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: 5,
              }}
            >
              <Typography variant="h5" fontWeight="bold" mb={2} >
                📸 {t.galleryTitle}
              </Typography>

              <Typography variant="h6" mb={3} color="#070707">
                {t.galleryDesc}
              </Typography>

              <MKButton
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(45deg, #b8860b, #ffd700)",
                  color: "#070707",
                  fontWeight: "bold",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #ffd700, #b8860b)",
                  },
                }}
                size="large"
                href="https://1drv.ms/f/c/1242502a6d9c60ee/IgDzuNDhZFJMRahmF0yCFJysARMJpJdeuxNbgcCGpjg2ioc?e=xdlshH"
                target="_blank"
              >
                📂{t.galleryBtn}
              </MKButton>
            </Paper>
          </Grid>

          {/* 📺 YOUTUBE */}
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                height: "100%",
                p: 4,
                borderRadius: 4,
                textAlign: "center",
                backgroundImage: `linear-gradient(
                 rgba(218, 178, 70, 0.48),
                  rgba(231, 211, 110, 0.9)
                ), url(${cardBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: 5,
              }}
            >
              <Typography variant="h5" fontWeight="bold" mb={2}>
                📺 {t.youtubeTitle}
              </Typography>

              <Typography variant="h6" mb={3} color="#080808">
                {t.youtubeDesc}
              </Typography>

              <MKButton
                variant="contained"
                sx={{
                  background:
                    "linear-gradient(45deg, #8b0000, #ff4d4d)",
                  color: "#131212",
                  fontWeight: "bold",
                  "&:hover": {
                    background:
                      "linear-gradient(45deg, #ff4d4d, #8b0000)",
                  },
                }}
                size="large"
                href="https://youtube.com/@sriambabhavanihulikere-i8h"
                target="_blank"
              >
                ▶️ {t.youtubeBtn}
              </MKButton>
            </Paper>
          </Grid>

          {/* 📍 MAP */}
          {/* Map Section */} <Grid item xs={12}> <Paper elevation={3} sx={{
            backgroundImage: `linear-gradient(
                rgba(218, 178, 70, 0.48),
                  rgba(231, 211, 110, 0.9)
                ),url(${cardBg})`, p: 3, borderRadius: 3
          }}> <Typography variant="h5" mb={2} color="#262926"> 📍 {t.mapTitle} </Typography> <MKBox

            sx={{ borderRadius: 2, overflow: "hidden" }}>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3881.4030844783356!2d75.95913139999999!3d13.3873491!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbac5016a4beeef%3A0xf4ecfbbb1f73fb3a!2z4LK24LON4LKw4LOAIOCyheCyguCyrOCyvuCyreCyteCyvuCyqOCyvyDgsoXgsq7gs43gsq7gsqjgsrXgsrAg4LKm4LOH4LK14LK44LON4LKl4LK-4LKoLCDgsrngs4HgsrLgsr_gspXgs4bgsrDgs4Y!5e0!3m2!1sen!2sin!4v1769835416437!5m2!1sen!2sin" width="100%" height="350" style={{ border: 0 }} allowFullScreen loading="lazy" title="Temple Location" />
            </MKBox> </Paper> </Grid> </Grid>

      </Container>
    </MKBox>
  );
}

export default Home;
